export function getHrefLangData(siteURL, siteTag, pagePath, manualHrefLangs) {
  const siteConfigs = {
    'site:chefcollective': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'en-au', href: `${siteURL}${pagePath}` },
    ],
    'site:cloudkitchens': [
      { hrefLang: 'en-us', href: `${siteURL}${pagePath}` },
    ],
    'site:cocinas-ocultas': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'es-pe', href: `${siteURL}${pagePath}` },
    ],
    'site:everplate': [
      { hrefLang: 'x-default', href: `${siteURL}/id${pagePath}` },
      { hrefLang: 'id-id', href: `${siteURL}/id${pagePath}` },
      { hrefLang: 'en-us', href: `${siteURL}/en${pagePath}` },
    ],
    'site:freshlane': [
      { hrefLang: 'x-default', href: `${siteURL}/zh${pagePath}` },
      { hrefLang: 'zh-hk', href: `${siteURL}/zh${pagePath}` },
      { hrefLang: 'en-hk', href: `${siteURL}/en${pagePath}` },
    ],
    'site:kitchen-central': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'pt-br', href: `${siteURL}${pagePath}` },
    ],
    'site:kitchenbase': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'ja-jp', href: `${siteURL}${pagePath}` },
    ],
    'site:kitchennow': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'zh-tw', href: `${siteURL}${pagePath}` },
    ],
    'site:kitchenpark': pagePath.includes('/blog')
      ? [
          { hrefLang: 'x-default', href: `${siteURL}/ar-sa${pagePath}` },
          { hrefLang: 'ar-sa', href: `${siteURL}/ar-sa${pagePath}` },
        ]
      : [
          { hrefLang: 'x-default', href: `${siteURL}/ar-sa${pagePath}` },
          { hrefLang: 'ar-sa', href: `${siteURL}/ar-sa${pagePath}` },
          { hrefLang: 'en-ae', href: `${siteURL}/en${pagePath}` },
          { hrefLang: 'ar-ae', href: `${siteURL}/ar-ae${pagePath}` },
          { hrefLang: 'ar-kw', href: `${siteURL}/ar-kw${pagePath}` },
        ],
    'site:kitchenvalley': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'ko-kr', href: `${siteURL}${pagePath}` },
    ],
    'site:pedidoslab': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'es-es', href: `${siteURL}${pagePath}` },
    ],
    'site:profood-solutions': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'en-gb', href: `${siteURL}${pagePath}` },
    ],
    'site:smartcity-kitchens': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'en-sg', href: `${siteURL}${pagePath}` },
    ],
    'site:virtual-kitchens': [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
      { hrefLang: 'es-mx', href: `${siteURL}${pagePath}` },
    ],
  };

  if (manualHrefLangs?.length) {
    return manualHrefLangs.map((item) => ({
      hrefLang: item.hreflang,
      href: `${siteURL}${item.href}`,
    }));
  }

  return (
    siteConfigs[siteTag] || [
      { hrefLang: 'x-default', href: `${siteURL}${pagePath}` },
    ]
  );
}
